import { render, staticRenderFns } from "./Msgtwo.vue?vue&type=template&id=4228f749&scoped=true&"
import script from "./Msgtwo.vue?vue&type=script&lang=js&"
export * from "./Msgtwo.vue?vue&type=script&lang=js&"
import style0 from "./Msgtwo.vue?vue&type=style&index=0&id=4228f749&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4228f749",
  null
  
)

component.options.__file = "Msgtwo.vue"
export default component.exports